export default __webpack_public_path__ + "static/media/Marathi_df_2.2ea2dc6b.mp3";